module.exports = __webpack_public_path__ + "img/about-safety.b4e63164.jpg";